var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Product(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.095,
    height: 32.822,
    viewBox: "0 0 31.095 32.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-product",
    d: "M8.159,5A2.179,2.179,0,0,0,6,7.159v6.046a2.185,2.185,0,0,0,1.727,2.116V33.936a3.907,3.907,0,0,0,3.887,3.887H31.481a3.907,3.907,0,0,0,3.887-3.887V15.321a2.185,2.185,0,0,0,1.727-2.116V7.159A2.179,2.179,0,0,0,34.936,5Zm.432,2.591H34.5v5.182H8.591Zm1.727,7.774H32.776V33.936a1.276,1.276,0,0,1-1.3,1.3H11.614a1.276,1.276,0,0,1-1.3-1.3Zm7.342,3.455a1.3,1.3,0,1,0,0,2.591h7.774a1.3,1.3,0,1,0,0-2.591Z",
    transform: "translate(-6 -5)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Product);
export default __webpack_public_path__ + "static/media/icons8-product.69c718d8.svg";
export { ForwardRef as ReactComponent };